import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import {useTranslation} from "react-i18next";
import {PAGE_HOME} from "../../locales/pages/namespaces";
import ShippingWaysContent from "../../components/general/staticPages/shippingWaysContent";

const ShippingWays = ()=>{
    const { t } = useTranslation(PAGE_HOME);
    return (
        <Box
            sx={{
                width: "95%",
                maxWidth: 1760,
                mx: "auto",
                bgcolor: "#E9E9E9",
                borderRadius: "30px",
                px: { xs: 2, md: 6 },
                py: { xs: 4, md: 6 },
            }}
        >
            <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
                <Grid item xs={12} md={11}>
                 <ShippingWaysContent/>
                </Grid>
            </Grid>
        </Box>

    );
}
export default ShippingWays